import React, { useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  makeStyles,
  Typography,
  Grid,
  TextField,
  Button,
  Box,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormGroup,
  RadioGroup,
  Radio,
  Checkbox,
} from "@material-ui/core";
import "./App.css";
import emailjs from "@emailjs/browser";

const useStyles = makeStyles({
  card: {
    background: "#f3f3f3",
    //maxWidth: 400,
    height: "auto",
    marginTop: "20px",
    marginBottom: "20px",
    marginLeft: "10%",
    marginRight: "10%",
    //borderRadius: 5,
    //border: "5px solid #e4943b",
    //borderLeft: "50px",
    //boxShadow: "0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);",
    //padding: "0px",
    //padding: "5px",
    //paddingLeft: "70px",
    //paddingRight: "70px",
  },
  titleHead: {
    // color: "#0c3c5c",
    // background: "#e4943b",
    color: "#e4943b",
    background: "#0c3c5c",
    border: "5px solid #0c3c5c",
    //fontWeight: "bolder",
    textAlign: "center",
    //padding: "10px",
    //marginTop: "20px",
  },
  content: {
    color: "#0c3c5c",
    border: "5px solid #f3f3f3",
    padding: "10px",
    //marginBottom: "20px",
    height: "auto",
    fontSize: 20,
    //fontWeight: "bold",
  },
  grid: {
    flexGrow: 1,
    flexDirection: "row",
    //border: "10px",
    //margin: "10px",
    marginTop: "20px",
  },
  media: {
    height: "100%",
    width: "100%",
  },
  button: {
    color: "#1e8678",
    fontWeight: "bold",
    fontSize: 12,
  },
  headLine: {
    color: "#e4943b",
    textAlign: "center",
    fontSize: 30,
    fontWeight: "bold",
  },
  headContent: {
    color: "#0c3c5c",
    textAlign: "center",
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: "20px",
  },
});

export default function Register() {
  const classes = useStyles();
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = () => {
    setIsSubmitting(true);
    setSubmissionStatus(null);

    emailjs
      .sendForm("service_jhqqvaj", "template_m5rt587", form.current, {
        publicKey: "pwTHmtq8YM2cKpDeO",
      })
      .then(
        () => {
          setSubmissionStatus("success");
          setIsSubmitting(false);
        },
        () => {
          setSubmissionStatus("error");
          setIsSubmitting(false);
        },
      );
  };

  return (
    <div>
      <Box p={3} maxWidth={600} mx="auto">
        <Typography variant="h4" gutterBottom className={classes.content}>
          Register
        </Typography>
        <Typography className={classes.headLine}>
          Thanks for choosing FL Swimming!
        </Typography>
        <Typography className={classes.headContent}>
          To help us find the best swim class for you or your child, please take
          a moment to fill out the registration form below.
        </Typography>

        <form
          ref={form}
          onSubmit={handleSubmit(onSubmit, (errors) => {
            console.error("Form errors:", errors);
          })}
        >
          <Grid
            container
            spacing={2}
            justifyContent="center"
            className={classes.grid}
          >
            <Grid item xs={9} sm={9}>
              <TextField
                label="First Name"
                id="firstName"
                fullWidth
                variant="outlined"
                name="firstName"
                {...register("firstName", {
                  required: "First name is required",
                })}
                error={!!errors.firstName}
                helperText={errors.firstName?.message}
              />
            </Grid>
            <Grid item xs={9} sm={9}>
              <TextField
                label="Last Name"
                id="lastName"
                fullWidth
                variant="outlined"
                name="lastName"
                {...register("lastName", { required: "Last name is required" })}
                error={!!errors.lastName}
                helperText={errors.lastName?.message}
              />
            </Grid>
            <Grid item xs={9} sm={9}>
              <TextField
                label="Age"
                id="age"
                fullWidth
                variant="outlined"
                name="age"
                {...register("age", { required: "Age is required" })}
                error={!!errors.age}
                helperText={errors.age?.message}
              />
            </Grid>
            <Grid item xs={9} sm={9}>
              <TextField
                label="Email"
                id="email"
                fullWidth
                variant="outlined"
                name="email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Invalid email address",
                  },
                })}
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            </Grid>
            <Grid item xs={9} sm={9}>
              <TextField
                label="Phone"
                id="phone"
                fullWidth
                variant="outlined"
                name="phone"
                {...register("phone", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Invalid phone number",
                  },
                })}
                error={!!errors.phone}
                helperText={errors.phone?.message}
              />
            </Grid>
            <Grid item xs={9} sm={9}>
              <FormControl component="fieldset" error={!!errors.experience}>
                <FormLabel component="legend">Swimming Experience</FormLabel>
                <Controller
                  name="experience"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Please select a swimming experience" }}
                  render={({ field }) => (
                    <RadioGroup row {...field}>
                      <FormControlLabel
                        value="Beginner"
                        control={<Radio />}
                        label="Beginner"
                      />
                      <FormControlLabel
                        value="Some experience"
                        control={<Radio />}
                        label="Some experience"
                      />
                      <FormControlLabel
                        value="Comfortable swimmer"
                        control={<Radio />}
                        label="Comfortable swimmer"
                      />
                      <FormControlLabel
                        value="Advanced"
                        control={<Radio />}
                        label="Advanced"
                      />
                    </RadioGroup>
                  )}
                />
                {errors.experience && (
                  <Typography color="error" variant="body2">
                    {errors.experience.message}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={9} sm={9}>
              <FormControl
                component="fieldset"
                error={!!errors.preferredClassType}
              >
                <FormLabel component="legend">Preferred Class Type</FormLabel>
                <Controller
                  name="preferredClassType"
                  control={control}
                  defaultValue={""}
                  rules={{ required: "Please select a preferred class type" }}
                  render={({ field }) => (
                    <RadioGroup row {...field}>
                      <FormControlLabel
                        value="Private Lesson (1:1, 60 minutes)"
                        control={<Radio />}
                        label="Private Lesson (1:1, 60 minutes)"
                      />
                      <FormControlLabel
                        value="Private Lesson (1:1, 30 minutes)"
                        control={<Radio />}
                        label="Private Lesson (1:1, 30 minutes)"
                      />
                      <FormControlLabel
                        value="Semi-Private Lesson (1:2)"
                        control={<Radio />}
                        label="Semi-Private Lesson (1:2)"
                      />
                      <FormControlLabel
                        value="Group Lesson (1:4)"
                        control={<Radio />}
                        label="Group Lesson (1:4)"
                      />
                      <FormControlLabel
                        value="Team (1:6)"
                        control={<Radio />}
                        label="Team (1:6)"
                      />
                    </RadioGroup>
                  )}
                />
                {errors.preferredClassType && (
                  <Typography color="error" variant="body2">
                    {errors.preferredClassType.message}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={9} sm={9}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Preferred Time</FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register("preferredTimes")}
                        value="Weekdays 3-5pm"
                      />
                    }
                    label="Weekdays 3-5pm"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register("preferredTimes")}
                        value="Weekdays 5-7pm"
                      />
                    }
                    label="Weekdays 5-7pm"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register("preferredTimes")}
                        value="Weekdays 7-9pm"
                      />
                    }
                    label="Weekdays 7-9pm"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register("preferredTimes")}
                        value="Weekend Morning"
                      />
                    }
                    label="Weekend Morning"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register("preferredTimes")}
                        value="Weekend Afternoon"
                      />
                    }
                    label="Weekend Afternoon"
                  />
                </FormGroup>
              </FormControl>
            </Grid>

            {/* Notes Field */}
            <Grid item xs={9} sm={9}>
              <TextField
                label="Notes (optional)"
                id="notes"
                fullWidth
                variant="outlined"
                name="notes"
                multiline
                rows={4}
                inputProps={{ maxLength: 500 }}
                {...register("notes", {
                  maxLength: {
                    value: 500,
                    message: "Notes cannot exceed 500 characters",
                  },
                })}
                error={!!errors.notes}
                helperText={
                  errors.notes?.message ||
                  "You can add any preferences, concerns, or extra info."
                }
              />
              <Typography variant="body2" color="textSecondary" align="right">
                {watch("notes")?.length || 0} / 500
              </Typography>
            </Grid>

            <Grid item xs={9}>
              <Typography variant="body2" color="textSecondary">
                Privacy notice: FL Swimming will use the information you provide
                to respond to your registration request and contact you about
                lesson scheduling. We do not sell your personal information.
              </Typography>
            </Grid>

            {submissionStatus === "success" && (
              <Grid item xs={9}>
                <Typography role="status" aria-live="polite" color="primary">
                  Thank you—your registration request has been sent. We’ll
                  contact you as soon as possible to confirm your class
                  schedule.
                </Typography>
              </Grid>
            )}

            {submissionStatus === "error" && (
              <Grid item xs={9}>
                <Typography role="alert" color="error">
                  We couldn’t send your registration request. Your information
                  is still in the form; please try again.
                </Typography>
              </Grid>
            )}

            <Grid item xs={9}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                disabled={isSubmitting || submissionStatus === "success"}
              >
                {isSubmitting
                  ? "Sending..."
                  : submissionStatus === "success"
                    ? "Request sent"
                    : submissionStatus === "error"
                      ? "Try again"
                      : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </form>
        <Typography className={classes.headContent}>
          Once we receive your submission, we’ll contact you as soon as possible
          to confirm your class schedule.
          <br />
          If you have any specific preferences — such as the class type, skill
          level, or scheduling needs — feel free to include them in the form or
          contact us by phone or email after submitting.
        </Typography>
      </Box>
    </div>
  );
}
